import { render, staticRenderFns } from "./MySummary.vue?vue&type=template&id=b8bf00e8&scoped=true&"
import script from "./MySummary.vue?vue&type=script&lang=js&"
export * from "./MySummary.vue?vue&type=script&lang=js&"
import style0 from "./MySummary.vue?vue&type=style&index=0&id=b8bf00e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bf00e8",
  null
  
)

export default component.exports